// src/components/Home.js

import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const calculators = [
  {
    id: 'RS',
    title: 'REPUBLIKA SRPSKA',
    description: 'Obračuni plate sa uvećanjima i odbicima, različitih vrsta ugovora, obaveza i obračun staža.',
  },
  { id: 'kalkulator-FBIH',
    title: 'FEDERACIJA BIH (beta)',
    description: 'Obračuni plate i doprinosa za puno radno vrijeme u FBIH, sa toplim obrokom, uvećanjima i odbicima.',
  },
];

export default function Home() {
  return (
    <div className="home-wrapper">
      <h1 className="home-title">IZABERITE ENTITET ZA OBRAČUN</h1>
      <div className="cards-grid">
        {calculators.map((calc) => (
          <Link
            key={calc.id}
            to={`/${calc.id}`}
            className="card-link"
          >
            <div className="card">
              <h2 className="card-heading">{calc.title}</h2>
              <p className="card-desc">{calc.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
